import { render, staticRenderFns } from "./filter-new-ux.vue?vue&type=template&id=79956d36&"
import script from "./filter-new-ux.vue?vue&type=script&lang=js&"
export * from "./filter-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79956d36')) {
      api.createRecord('79956d36', component.options)
    } else {
      api.reload('79956d36', component.options)
    }
    module.hot.accept("./filter-new-ux.vue?vue&type=template&id=79956d36&", function () {
      api.rerender('79956d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/filter-new-ux.vue"
export default component.exports